import React from 'react';
import logo from '../../assets/icons/MetaBrief_horizontal_RBG.png'
const Loading = () => {
  return (
    <div className="page-loader-wrapper">
        {/* Page Loader  */}
        <div className="loader">
            <div className="m-t-30"><img src={logo} width="100" height="60" alt="HexaBit"/></div>
            <p>Please wait...</p>        
        </div>
    </div>
  );
};

export default Loading;
